<div class="edit-form">
    <ng-container *ngIf="!hideName">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{'form.name'|translate}}</mat-label>
            <mat-icon matPrefix>label</mat-icon>
            <input matInput type="text" [(ngModel)]="config.name" (ngModelChange)="nameError = ''">
        </mat-form-field>

        <div *ngIf="nameError" class="error-banner">
            <mat-icon fontIcon="error"></mat-icon>
            <span>{{nameError}}</span>
        </div>
    </ng-container>

    <div class="header-input">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{'form.type'|translate}}</mat-label>
            <mat-icon matPrefix>category</mat-icon>
            <mat-select class="accuracy" [(ngModel)]="config.type" [disabled]="!!lockType"
                (selectionChange)="onTypeChanged()">
                <mat-option value="Unit" *ngIf="!excludeTypes.includes('Unit')">Unit</mat-option>
                <mat-option value="GPS RTK" *ngIf="!excludeTypes.includes('GPS RTK')">GPS RTK</mat-option>
                <mat-option value="KYD" *ngIf="!excludeTypes.includes('KYD')">KYD</mat-option>
                <mat-option value="ELSA" *ngIf="!excludeTypes.includes('ELSA')">ELSA</mat-option>
                <mat-option value="Tablet" *ngIf="!excludeTypes.includes('Tablet')">Tablet</mat-option>
                <mat-option value="Sigfox" *ngIf="!excludeTypes.includes('Sigfox')">Sigfox</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>
                {{'units.device.offline_delai'|translate}}
            </mat-label>
            <mat-icon matPrefix>schedule</mat-icon>
            <input matInput [(ngModel)]="config.offlineDelay" type="number" placeholder="60">
        </mat-form-field>
    </div>

    <div [ngSwitch]="config.type" class="flex">
        <div class="config-input" *ngSwitchCase="'KYD'">
            <h2>KYD Settings</h2>

            <div class="flex-input">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'units.device.mode'|translate}}</mat-label>
                    <mat-icon matPrefix>tune</mat-icon>
                    <mat-select [(ngModel)]="kydMode">
                        <mat-option value="easy">{{'units.device.mode_easy'|translate}}</mat-option>
                        <mat-option value="advanced">{{'units.device.mode_advanced'|translate}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex-input" *ngIf="kydMode === 'easy'">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'units.device.alert_distance'|translate}} (m)</mat-label>
                    <mat-icon matPrefix>swap_calls</mat-icon>
                    <input matInput [ngModel]="unfriendDistanceText" (ngModelChange)="onUnfriendDistanceTextChange($event)"
                        (blur)="onUnfriendDistanceTextBlur()" type="text" inputmode="decimal" placeholder="20">
                </mat-form-field>
            </div>

            <div class="flex-input" *ngIf="kydMode !== 'easy'">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'trackers.selfAlertDistance'|translate}} (m)</mat-label>
                    <mat-icon matPrefix>swap_calls</mat-icon>
                    <input matInput [ngModel]="minDistanceText" (ngModelChange)="onMinDistanceTextChange($event)"
                        (blur)="onMinDistanceTextBlur()" type="text" inputmode="decimal"
                        placeholder="5">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'trackers.otherAlertDistance'|translate}} (m)</mat-label>
                    <mat-icon matPrefix>swap_calls</mat-icon>
                    <input matInput [ngModel]="maxDistanceText" (ngModelChange)="onMaxDistanceTextChange($event)"
                        (blur)="onMaxDistanceTextBlur()" type="text" inputmode="decimal"
                        placeholder="15">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'trackers.friendGroup'|translate}}</mat-label>
                    <mat-icon matPrefix>person_add</mat-icon>
                    <input matInput [(ngModel)]="config.settings.friendGroup" type="number" placeholder="1">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'trackers.ignoreGroup'|translate}}</mat-label>
                    <mat-icon matPrefix>block</mat-icon>
                    <input matInput [(ngModel)]="config.settings.ignoreGroup" type="number" placeholder="0">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'trackers.unfriendDistanceLabel'|translate}} (m)</mat-label>
                    <mat-icon matPrefix>logout</mat-icon>
                    <input matInput [ngModel]="unfriendDistanceText" (ngModelChange)="onUnfriendDistanceTextChange($event)"
                        (blur)="onUnfriendDistanceTextBlur()" type="text" inputmode="decimal"
                        placeholder="20">
                </mat-form-field>
            </div>

            <div class="flex-input exclusion-row" *ngIf="kydMode !== 'easy'">
                <div class="exclusion-toggle">
                    <mat-slide-toggle [(ngModel)]="exclusionModeEnabled">{{'trackers.exclusionModeEnabled'|translate}}</mat-slide-toggle>
                </div>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{'trackers.exclusionDistanceLabel'|translate}} (m)</mat-label>
                    <mat-icon matPrefix>block</mat-icon>
                    <input matInput [ngModel]="exclusionDistanceText" (ngModelChange)="onExclusionDistanceTextChange($event)"
                        (blur)="onExclusionDistanceTextBlur()" type="text" inputmode="decimal"
                        [disabled]="!exclusionModeEnabled" placeholder="1">
                </mat-form-field>
            </div>

            <div *ngIf="distanceError" class="error-banner">
                <mat-icon fontIcon="error"></mat-icon>
                <span>{{distanceError}}</span>
            </div>
        </div>

        <div class="config-input full-width" *ngSwitchCase="'Sigfox'">
            <h2>Sigfox Settings</h2>

            <div class="config-content">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>
                        {{'units.device.payload_config'|translate}}
                    </mat-label>
                    <mat-icon matPrefix>settings_ethernet</mat-icon>
                    <input matInput [(ngModel)]="config.settings.payloadConfig" type="text" placeholder="1">
                </mat-form-field>

                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-label>
                        {{'units.device.body_template'|translate}}
                    </mat-label>
                    <mat-icon matPrefix>code</mat-icon>
                    <textarea matInput [(ngModel)]="config.settings.bodyTemplate" rows="10"
                        (blur)="checkBodyTemplate()"></textarea>

                    <p *ngIf="bodyTemplateError" class="error">{{bodyTemplateError}}</p>
                </mat-form-field>
            </div>
        </div>

        <!-- Not for KYD: its settings are a fixed shape written to the sensor over BLE (see
             TrackerConfigTool.mapFlatToNested()), custom fields would never be saved. -->
        <div class="config-input" *ngIf="config.type !== 'KYD'">
            <h2>Custom Settings</h2>

            <div class="flex-input column">
                @for(setting of getCustomFields(); track setting.label) {
                <div class="custom-input">
                    <lib-custom-input class="custom-input-field" [config]="setting"></lib-custom-input>
                    <lib-button color="none" textColor="danger" icon="close" (click)="removeField(setting.label)"
                        class="remove-config-button"></lib-button>
                </div>
                }

                @if(newConfig) {
                <lib-custom-input-editor [config]="newConfig"></lib-custom-input-editor>

                <div class="row">
                    <lib-button color="outline" icon="close" (click)="newConfig = undefined"
                        class="add-config-button" text="{{'form.cancel'|translate}}">
                    </lib-button>

                    <lib-button color="primary" icon="save" (click)="saveField()" class="add-config-button"
                        text="{{'form.save'|translate}}">
                    </lib-button>
                </div>
                } @else {
                <lib-button color="primary" icon="add" (click)="addField()" class="add-config-button"
                    text="{{'form.add'|translate}}">
                </lib-button>
                }
            </div>
        </div>
    </div>

    <div class="button-group">
        <!-- hideCancel: the inline Ressources > Dispositif KYD flow has no separate "view"
             state to cancel back to. A dialog embedding this form (e.g. Rapport KYD's edit
             button) still wants Cancel to close it without saving. -->
        <lib-button *ngIf="!hideCancel" color="outline" (click)="cancelForm.emit()" icon="cancel"
            text="{{'form.cancel'|translate}}"></lib-button>

        <lib-button *ngIf="hideName && !hideSaveAsTemplate" color="secondary" (click)="onSaveAsTemplate()" icon="bookmark_add"
            text="{{'resources.save_as_template'|translate}}"></lib-button>

        <lib-button *ngIf="!hideSave" color="primary" (click)="onSave()" icon="save" text="{{'form.save'|translate}}"></lib-button>
    </div>
</div>
